export const DOCUMENT_TYPE_OPTIONS = [
  { value: 'factura', label: 'Factura' },
  { value: 'boleta', label: 'Boleta' },
  { value: 'recibo_por_honorarios', label: 'Recibo por Honorarios' },
  { value: 'nota_credito', label: 'Nota de Crédito' },
  { value: 'nota_debito', label: 'Nota de Débito' },
  { value: 'otro', label: 'Otro' },
];

/** Tipos válidos como documento de referencia (notas crédito/débito). */
export const REFERENCE_DOCUMENT_TYPE_OPTIONS = DOCUMENT_TYPE_OPTIONS;

export function getDocumentTypeLabel(type, { uppercase = false } = {}) {
  if (!type) return '—';
  const found = DOCUMENT_TYPE_OPTIONS.find((o) => o.value === type);
  const label = found?.label || String(type).replace(/_/g, ' ');
  return uppercase ? label.toUpperCase() : label;
}
